import type { UserRole } from '@plane/shared';
import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';

import { useAuth } from '@/modules/auth/hooks/auth-context';

interface ItemDeNavegacao {
  readonly to: string;
  readonly label: string;
  readonly end: boolean;
  /** Ausente = visível para todo mundo. */
  readonly papeis?: readonly UserRole[];
}

const NAV_ITEMS: readonly ItemDeNavegacao[] = [
  { to: '/', label: 'Visão geral', end: true },
  { to: '/projetos', label: 'Projetos', end: false },
  { to: '/usuarios', label: 'Usuários', end: false, papeis: ['ADMIN'] },
];

/** Casca autenticada do painel: navegação lateral e área de conteúdo. */
export function AdminLayout() {
  const { usuario, sair } = useAuth();
  const navigate = useNavigate();
  const [saindo, setSaindo] = useState(false);

  async function aoSair() {
    setSaindo(true);

    try {
      await sair();
      // `replace` para o botão Voltar não devolver a pessoa ao painel.
      void navigate('/login', { replace: true });
    } finally {
      setSaindo(false);
    }
  }

  return (
    <div className="grid min-h-screen lg:grid-cols-[240px_1fr]">
      <aside className="flex flex-col bg-brand-950 px-5 py-6 text-bone">
        <span className="font-display text-lg">
          Plane <span className="italic text-brand-150">Móveis</span>
        </span>

        <nav className="mt-8 flex flex-col gap-1" aria-label="Navegação do painel">
          {NAV_ITEMS.filter(
            (item) => !item.papeis || (usuario && item.papeis.includes(usuario.role)),
          ).map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `px-3 py-2 text-sm transition-colors ${
                  isActive ? 'bg-brand-800 text-bone' : 'text-brand-150 hover:bg-brand-900'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Os demais itens de navegação entram conforme cada módulo é implementado. */}

        <div className="mt-auto border-t border-brand-800 pt-4">
          {usuario && (
            <div className="px-3">
              <p className="truncate text-sm text-bone" title={usuario.name}>
                {usuario.name}
              </p>
              <p className="truncate text-xs text-brand-150" title={usuario.email}>
                {usuario.email}
              </p>
            </div>
          )}

          <button
            type="button"
            onClick={() => void aoSair()}
            disabled={saindo}
            className="mt-3 w-full px-3 py-2 text-left text-sm text-brand-150 transition-colors hover:bg-brand-900 hover:text-bone disabled:opacity-60"
          >
            {saindo ? 'Saindo…' : 'Sair'}
          </button>
        </div>
      </aside>

      <main className="px-6 py-8 lg:px-10">
        <Outlet />
      </main>
    </div>
  );
}
